'use client';

import * as React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useDeleteOffers } from '@/lib/api/offers';

interface DeleteOfferModalProps {
    offerId?: string;
    storeId: string;
    onClose: () => void;
}

/**
 * DeleteOfferModal component for confirming deletion of a single offer
 */
export const DeleteOfferModal = ({ offerId, storeId, onClose }: DeleteOfferModalProps) => {
    const deleteOffersMutation = useDeleteOffers();

    const handleDelete = async () => {
        if (!offerId) return;
        await deleteOffersMutation.mutateAsync({ offerIds: [offerId], storeId });
        onClose();
    };

    return (
        <AlertDialog open={!!offerId} onOpenChange={onClose}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Delete offer?</AlertDialogTitle>
                    <AlertDialogDescription>
                        This action cannot be undone. This will permanently delete this offer from your store.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={handleDelete}
                        disabled={deleteOffersMutation.isPending}
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                    >
                        {deleteOffersMutation.isPending ? 'Deleting...' : 'Delete'}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
